import { IoSchool } from "react-icons/io5";
import { useGlobalContext } from "./context/globalContext";
import React, { useState, useRef, useEffect } from "react";
import { MdHealthAndSafety } from "react-icons/md";
import { FaShoppingCart, FaUtensils } from "react-icons/fa";
import { FaMapLocation } from "react-icons/fa6";

const LocationBenefits2 = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  const [activeDetail, setActiveDetail] = useState(null);
  const detailsRef = useRef(null);

  // Handle click outside to close details
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the details and the icon
      if (
        detailsRef.current &&
        !detailsRef.current.contains(event.target) &&
        !event.target.closest(".benefit-icon")
      ) {
        setActiveDetail(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle icon click
  const handleIconClick = (index, event) => {
    event.stopPropagation();
    setActiveDetail(activeDetail === index ? null : index);
  };
  const benefits = [
    {
      icon: <IoSchool />,
      title: "Educational Institutes",
      details: [
        "SVPM Scl - 550 m",
        "Bharat Grp Of Scls & Clgs - 1.4 km",
        "Blossom English Scl - 1.7 km",
        "Lok Puram Public Scl - 5.8 km",
      ],
    },
    {
      icon: <MdHealthAndSafety />,
      title: "Hospitals",
      details: [
        "Prakruti Care Hospital - 1 km",
        "Chhatrapati Shivaji Maharaj Hospital - 2 km",
        "Jupiter Hospital - 4.7 km",
        "Bethany Hospital - 5.6 km",
      ],
    },
    {
      icon: <FaUtensils />,
      title: "Restaurants",
      details: [
        "Veg Planet - 4 km",
        "Vrindas Veg Treat - 3 km",
        "Irani Chaiko's - 5 km",
        "All Day Kitchen & Cafe - 6 km",
      ],
    },
    {
      icon: <FaShoppingCart />,
      title: "Malls",
      details: [
        "Eternity Mall - 4.7 km",
        "Korum Mall - 5.2 km",
        "Viviana Mall - 5.4 km",
        "R Mall - 6.1 km",
      ],
    },
    {
      icon: <FaMapLocation />,
      title: "Connectivity",
      details: [
        "Thane Station - 3.4 km",
        "Eastern Express Hwy - 5.4 km",
        "Mumbai-Nashik Hwy - 5 km",
        "Airoli Station - 6.8 km",
      ],
    },
  ];
  return (
    <>
      <div className="section shadow-sm lazyloaded">
        <div className="lb-container">
          <div className="lb-map">
            <img src="/images/lb.PNG" alt="Location Overview" />
          </div>
          <div className="lb-content">
            <div className="lb-content-body">
              <h2 className="head text-capitalize text-center">
                {project} - Location & Connectivity
              </h2>
              <div className="cards">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className={`crd position-${index + 1}  ${
                      activeDetail === index ? "alive-card" : ""
                    } `}
                  >
                    <div
                      className="crd-icon"
                      onClick={(e) => handleIconClick(index, e)}
                    >
                      {benefit.icon}
                      <span className="crd-title">{benefit.title}</span>
                    </div>
                    <div
                      ref={activeDetail === index ? detailsRef : null}
                      className={`crd-details ${
                        activeDetail === index ? "active" : ""
                      }`}
                      id="card-details-scroll"
                    >
                      <ul>
                        {/* {benefit.details.map((detail, idx) => (
                          <li key={idx}>{detail}</li>
                        ))} */}
                        {benefit.details.map((detail, idx) => {
                          const parts = detail.split(" - "); // Using " – " (en dash) for separation
                          if (parts.length === 2) {
                            return (
                              <li key={idx}>
                                <span>{parts[0]}</span>

                                <span>{parts[1]}</span>
                              </li>
                            );
                          } else {
                            return <li key={idx}>{detail}</li>; // Handle cases with no " – "
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lb-content-footer">
              <span
                className="new-button "
                onClick={() => handleShowModal("Location Benefits")}
              >
                <span className="new-button-inner">
                  <span className="underline-animation">Get All Details</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocationBenefits2;
